import React from "react";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { Accordion, AccordionProps } from "./Accordion";
import * as styles from "./Accordions.module.css";

interface Props extends ComponentProps, ComponentWidth {
  accordions?: AccordionProps[];
  heading: string;
}

export const Accordions: React.FC<Props> = ({
  accordions,
  heading,
  width,
  ...props
}) => {
  const containerStyles = [styles.accordions];
  width === "contained" && containerStyles.push(styles.contained);
  return (
    <SectionWrapper {...props}>
      <div className={containerStyles.join(" ")}>
        {heading && <h2>{heading}</h2>}
        {accordions?.map((accordion, idx) => (
          <Accordion {...accordion} key={`accordion-${idx}`} />
        ))}
      </div>
    </SectionWrapper>
  );
};
